import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * Keeps Google Analytics / Google Ads off for staff traffic while navigating inside the app
 * (e.g. after logging in as admin, or opening /admin from the public site).
 * The rule itself lives in public/index.html (window.applyStaffTrafficOptOut), so it also applies
 * before the Google tag sends its first page view.
 */
export default function StaffTrafficGuard() {
    const {pathname} = useLocation();

    useEffect(() => {
        if (typeof window.applyStaffTrafficOptOut === 'function') {
            window.applyStaffTrafficOptOut();
        }
    }, [pathname]);

    return null;
}
